interface PageIntroProps {
  eyebrow?: string;
  title: string;
  summary: string;
}

export const PageIntro = ({ eyebrow, title, summary }: PageIntroProps) => (
  <section
    className="relative overflow-hidden bg-cover bg-center bg-no-repeat min-h-[650px] md:min-h-[750px] pt-16 md:pt-24 pb-12 md:pb-16 flex flex-col justify-between"
    style={{ backgroundImage: "url('/hero-bg.png')" }}
  >
    {/* Dark Navy Overlay */}
    <div className="absolute inset-0 bg-[#0E1C2C]/90 md:bg-gradient-to-r md:from-[#0E1C2C] md:via-[#0E1C2C]/85 md:to-[#0E1C2C]/50" />
 
    <div className="relative w-full px-6 lg:px-12 flex flex-col justify-center flex-grow">
      {/* Top: Left-aligned Intro Text */}
      <div className="space-y-8 text-white max-w-6xl pt-8 md:pt-16">
        {eyebrow ? (
          <p className="text-xs uppercase font-bold tracking-widest text-[#CEDC00]">
            {eyebrow}
          </p>
        ) : null}
        <h1 className="text-5xl font-display font-bold leading-tight md:text-6xl lg:text-7xl text-white">
          {title}
        </h1>
        <p className="max-w-4xl text-lg leading-relaxed text-slate-300 md:text-xl">
          {summary}
        </p>
      </div>
    </div>
  </section>
);
